import dayjs from 'dayjs';
import { TIME_FORMAT } from '../../constants';

/**
 * Convert time from 24-hour format to the 12-hour clock format (AM/PM) the app displays.
 *
 * Settings picked in a time picker are stored in the 24-hour format ("14:30"), so they
 * have to be read back the way they were entered ("02:30 PM").
 *
 * @param {string | undefined} timeString - Time string in 24-hour format (e.g., "14:30").
 * @returns {string | undefined} Time string in 12-hour clock format (e.g., "02:30 PM"),
 *   or `undefined` when there is no usable time to convert.
 */
export const convert24HourTo12HourFormat = (timeString) => {
  if (!timeString) return undefined;

  // Pinned to an arbitrary date so the time parses as a plain ISO local datetime --
  // dayjs only parses a bare "HH:mm" with the customParseFormat plugin loaded.
  const parsedTime = dayjs(`1970-01-01T${timeString}`);

  return parsedTime.isValid() ? parsedTime.format(TIME_FORMAT) : undefined;
};
